import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { TreeItemContentProps, useTreeItem } from "@mui/lab/TreeItem";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import * as React from "react";
import { forwardRef, ReactElement } from "react";

import EditCategoryDialog from "../../dialogs/category/edit-category";
import UserRole from "../../user-role/user-role";

function treeMenuContent(
  props: TreeItemContentProps,
  ref: React.Ref<HTMLDivElement>
): ReactElement {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
  } = props;

  const isEditableCategory = classes.selected.search("editable");

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const [editCategoryDialog, setEditCategoryDialog] =
    React.useState<boolean>(false);

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    preventSelection(event);
  };

  const handleExpansionClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    handleExpansion(event);
  };

  const handleSelectionClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    handleSelection(event);
  };

  return (
    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref as React.Ref<HTMLDivElement>}
    >
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>
      <UserRole>
        {isEditableCategory > 0 && (
          <div
            onClick={() => setEditCategoryDialog(true)}
            className={classes.iconContainer}
          >
            <EditOutlinedIcon className="!text-[15px]" />
          </div>
        )}
      </UserRole>
      <Typography
        onClick={handleSelectionClick}
        component="div"
        className={classes.label}
      >
        {label}
      </Typography>
      {editCategoryDialog && (
        <EditCategoryDialog
          isOpen={editCategoryDialog}
          categoryId={nodeId}
          onClose={() => setEditCategoryDialog(false)}
        />
      )}
    </div>
  );
}

export const TreeMenuContent = forwardRef(treeMenuContent);
